import { camelToSnake, snakeToCamel } from "caseparser";

import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

export const userLoyaltyApi = api
  .enhanceEndpoints({ addTagTypes: ["ticket", "tickets", "tasks", "lead-tasks"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      leadTasks: builder.query({
        query: ({ id }: any) => ({
          url: `/lead-tasks/${id}`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["lead-tasks"],
      }),

        getLeadTasks: builder.query<any[], { leadId: number | string }>({
          query: ({ leadId }) => ({
            url: `leads/${leadId}/tasks`,
            method: RequestMethod.GET,
          }),
         
          providesTags: ["lead-tasks"],
        }),

        
      allTasks: builder.query({
        query: ({ id, state }: any) => ({
          url: `/lead-tasks/all/${id}/${state}`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["lead-tasks"],
      }),
      storeTask: builder.mutation({
        invalidatesTags: ["lead-tasks"],
        query: (taskData) => ({
          url: "/lead-tasks/store",
          method: RequestMethod.POST,
          body: taskData,
        }),
      }),
      updateTask: builder.mutation({
        invalidatesTags: ["lead-tasks"],
        query: ({taskData, id}) => ({
          url: `/lead-tasks/${id}`,
          method: RequestMethod.POST,
          body: taskData,
        }),
      }),
      completeTask: builder.mutation({
        invalidatesTags: ["lead-tasks"],
        query: ({id}) => ({
          url: `/lead-tasks/complete/${id}`,
          method: RequestMethod.POST,
        }),
      }),
      notes: builder.query({
        query: ({ id }: any) => ({
          url: `/lead-tasks/notes/${id}`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["lead-tasks"],
      }),
      storeNotes: builder.mutation({
        invalidatesTags: ["lead-tasks"],
        query: (noteData) => ({
          url: "/lead-tasks/notes",
          method: RequestMethod.POST,
          body: noteData,
        }),
      }),

      ticketsUser: builder.query({
        query: ({ search, branchId }: any) => ({
          url: `/lead-tasks`,
          method: RequestMethod.GET,
          params: camelToSnake({
            search,
            branchId,
          }),
        }),
        providesTags: ["tickets"],
        transformResponse: (response: any) => snakeToCamel(response.data),
      }),
      storeTicket: builder.mutation({
        invalidatesTags: ["ticket"],
        query: (ticketData) => ({
          url: "/tickets/store",
          method: RequestMethod.POST,
          body: ticketData,
        }),
      }),
      updateUser: builder.mutation({
        invalidatesTags: ["ticket"],
        query: ({ id, active, name, email }: any) => ({
          url: `/users/${id}`,
          method: RequestMethod.PUT,
          body: snakeToCamel({
            active,
            name,
            email,
          }),
        }),
      }),
    }),
  });

export const {
  useLeadTasksQuery,
  useAllTasksQuery,
  useStoreTaskMutation,
  useLazyTicketsUserQuery,
  //update 
  useUpdateTaskMutation,
  useStoreTicketMutation,
  useGetLeadTasksQuery,
  useCompleteTaskMutation,
  useNotesQuery,
  useStoreNotesMutation,
} = userLoyaltyApi;
